import { useEffect, useState } from 'react';

const TABLET_QUERY = '(min-width: 768px) and (max-width: 1023.98px)';

const getMatches = (): boolean =>
	typeof window !== 'undefined' && typeof window.matchMedia === 'function'
		? window.matchMedia(TABLET_QUERY).matches
		: false;

export const useIsTablet = (): boolean => {
	const [isTablet, setIsTablet] = useState<boolean>(getMatches);

	useEffect(() => {
		const mql = window.matchMedia(TABLET_QUERY);
		const handler = (event: MediaQueryListEvent) => setIsTablet(event.matches);
		setIsTablet(mql.matches);
		mql.addEventListener('change', handler);
		return () => mql.removeEventListener('change', handler);
	}, []);

	return isTablet;
};
